import { FiAlertTriangle, FiCheckCircle, FiEdit, FiMail } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { renewalRegulation } from '../../Regulation.services.tsx';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const BannerUnpublished = ({
  id,
  draftId,
  title,
  forwardEmails,
  isCompanyAgreement,
  isInLeadership,
  showAttention,
  isReminderSent,
  isValid,
}: {
  id: number;
  draftId: number;
  title: string;
  forwardEmails: string | string[] | null;
  isCompanyAgreement: boolean;
  isInLeadership: boolean;
  showAttention: boolean;
  isValid: boolean;
  isReminderSent: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const renewalMutation = useMutation({
    mutationFn: () => renewalRegulation(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['draftRegulation'] });
      await queryClient.invalidateQueries({ queryKey: ['Regulation'] });
    },
    onError: () => {
      console.error('Failed to create Draft');
    },
  });

  const handleRenewal = () => renewalMutation.mutate();
  return (
    <div
      className={showAttention ? 'banner-alert banner-alert--warning' : 'banner-alert'}
      style={{
        display: 'flex',
        alignItems: showAttention ? 'flex-start' : 'center',
      }}
    >
      {showAttention && (
        <div>
          <FiAlertTriangle fontSize={20} color="#FF4D4F" />
        </div>
      )}
      <div className="banner-alert-content" style={{ width: '100%' }}>
        {showAttention && (
          <span className="banner-label">{t('banner.unpublished.title')}</span>
        )}
        {showAttention && (
          <span className="banner-content">{t('banner.unpublished.content')}</span>
        )}
        {(!isValid || isReminderSent) && (
          <>
            {!isInLeadership && (
              <div className="banner-actions">
                <Button
                  key="submit"
                  size="large"
                  icon={<FiMail />}
                  type="primary"
                  onClick={() => {
                    const recipients = Array.isArray(forwardEmails)
                      ? forwardEmails.join(',')
                      : String(forwardEmails);

                    const subject = encodeURIComponent(title || 'Regulation Draft');
                    const url = `${window.location.origin}/regulation/draft/view/${id}`;
                    const body = encodeURIComponent(`Link to the regulation:\n${url}`);
                    window.location.href = `mailto:${recipients}?subject=${subject}&body=${body}`;
                  }}
                >
                  {t('common.notify')}
                </Button>
              </div>
            )}
            {isCompanyAgreement && isInLeadership && (
              <div className="banner-actions">
                <Button
                  key="submit"
                  size="large"
                  icon={<FiCheckCircle />}
                  type="primary"
                  onClick={handleRenewal}
                >
                  {t('common.confirm-validity')}
                </Button>
                <Button
                  key="submit"
                  size="large"
                  icon={<FiMail />}
                  
                  onClick={() => {
                    const recipients = Array.isArray(forwardEmails)
                      ? forwardEmails.join(',')
                      : String(forwardEmails);

                    const subject = encodeURIComponent(title || 'Regulation Draft');
                    const url = `${window.location.origin}/regulation/draft/view/${id}`;
                    const body = encodeURIComponent(`Link to the regulation:\n${url}`);
                    window.location.href = `mailto:${recipients}?subject=${subject}&body=${body}`;
                  }}
                >
                  {t('common.notify')}
                </Button>
              </div>
            )}
            {!isCompanyAgreement && isInLeadership && (
              <div className="banner-actions">
                <Button
                  key="submit"
                  size="large"
                  icon={<FiCheckCircle />}
                  type="primary"
                  onClick={handleRenewal}
                >
                  {t('common.confirm-validity')}
                </Button>
                <Button
                  key="back"
                  icon={<FiEdit />}
                  size="large"
                  onClick={() => navigate(`/regulation/draft/${draftId}`)}
                >
                  {t('common.edit-regulation')}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BannerUnpublished;